/* dcg-search-overlay.js — v1.1, 03 AUG 2026
   Deleted an unused game-keyword detector and advanced-search URL builder.
   Both were written to route "View all results" to /pages/advanced-search and
   were never called — the button has always gone to /search. Removing them
   settles the contradiction with the desktop dropdown, which did use its own
   copy. Both surfaces now point at Shopify /search with identical params. */
(function () {
  (window.DCG = window.DCG || {}).searchOverlayVersion = "1.2";

  /* Route from the global that layout/theme.liquid:141-149 publishes rather
     than hardcoding "/search". Matters on locale- or market-prefixed
     storefronts, where routes.search_url is e.g. "/en-ca/search" and a
     hardcoded path would 404 or drop the customer out of their locale.
     Falls back to "/search" if the global is ever absent. */
  const SEARCH_URL = (window.routes && window.routes.searchUrl) || "/search";
  const overlay = document.getElementById("dcgSearchOverlay");
  const resultsEl = document.getElementById("dcgSearchResults");
  const showAllBtn = document.getElementById("dcgShowAllBtn");

  if (!overlay || !resultsEl || !showAllBtn) return;

  const form = overlay.querySelector(`form.search-header[action='${SEARCH_URL}']`);
  const input = form ? form.querySelector("input[name='q']") : null;

  if (!form || !input) return;

  let abortController = null;
  let lastTerm = "";

  function open() {
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function close() {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function money(cents) {
    try { return Shopify.formatMoney(cents); } catch (e) { return ""; }
  }

  function render(products) {
    if (!products || !products.length) {
      resultsEl.innerHTML = `<div style="color:rgba(255,255,255,.7);padding:10px;">No results.</div>`;
      return;
    }

    // Escape helper — prevents XSS via crafted product titles
    const esc = s => String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");

    resultsEl.innerHTML = products.map(p => {
      const img = p.image ? `<img loading="lazy" alt="" src="${esc(p.image)}">` : "";
      const price = (p.price_max === p.price_min) ? money(p.price) : `${money(p.price_min)} - ${money(p.price_max)}`;

      return `
        <a class="dcg-search-card" href="${esc(p.url)}">
          <div class="dcg-search-card__img">${img}</div>
          <div class="dcg-search-card__body">
            <div class="dcg-search-card__title">${esc(p.title || "")}</div>
            <div class="dcg-search-card__meta">
              <div class="dcg-search-card__price">${price}</div>
              <div class="dcg-search-card__stock">${p.available ? "In stock" : ""}</div>
            </div>
          </div>
        </a>
      `;
    }).join("");
  }

  async function fetchSuggest(term) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const res = await fetch(`${SEARCH_URL}/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=title,variants.title,product_type`, {
      signal: abortController.signal,
      headers: { "Accept": "application/json" }
    });

    return res.json();
  }

  function updateShowAll(term) {
    if (term.length >= 3) {
      showAllBtn.href = `${SEARCH_URL}?q=${encodeURIComponent(term)}&type=product&options[prefix]=last`;
      showAllBtn.textContent = `See all results for "${term}" →`;
    } else {
      showAllBtn.href = `${SEARCH_URL}?type=product`;
      showAllBtn.textContent = 'View all results →';
    }
  }

  let t = null;
  function onType() {
    const term = (input.value || "").trim();
    updateShowAll(term);

    if (term.length < 3) {
      resultsEl.innerHTML = `<div style="color:rgba(255,255,255,.7);padding:10px;">Type at least 3 characters.</div>`;
      return;
    }

    if (term === lastTerm) return;
    lastTerm = term;

    clearTimeout(t);
    t = setTimeout(async () => {
      try {
        const data = await fetchSuggest(term);
        const products = data?.resources?.results?.products || [];
        render(products);
        updateShowAll(term);
      } catch (e) {
        // aborted or error
      }
    }, 140);
  }

  // Open overlay when user focuses search
  input.addEventListener("focus", () => {
    open();
    updateShowAll((input.value || "").trim());
    onType();
  });

  input.addEventListener("input", onType);

  // Close handlers — closest() so taps on the SVG inside the close
  // button (rather than the button itself) still register.
  overlay.addEventListener("click", (e) => {
    if (e.target.closest("[data-dcg-close]")) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
  });

  // Focus trap — keeps Tab/Shift+Tab inside the overlay while it's open
  overlay.addEventListener("keydown", (e) => {
    if (e.key !== "Tab" || !overlay.classList.contains("is-open")) return;
    const focusable = Array.from(
      overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])')
    ).filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();